import { client } from '../../../../../common-utils/libraries/axios/axios';
import { RENTAL_FILES } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';
import rentalFilesFields from '../../fields/rentalFilesFields';

/**
 * @param response response.data object
 * @returns Mapped data object
 */
function mapResponseData(response) {
    return {
        [rentalFilesFields.UUID.key]: response[rentalFilesFields.UUID.key],
        [rentalFilesFields.FILE_NUMBER.key]: response[rentalFilesFields.FILE_NUMBER.key],
        [rentalFilesFields.TOTAL_AMOUNT.key]: response[rentalFilesFields.TOTAL_AMOUNT.key],
        [rentalFilesFields.STATUS.key]: response[rentalFilesFields.STATUS.key],
        [rentalFilesFields.BANK_CODE.key]: response[rentalFilesFields.BANK_CODE.key],
        [rentalFilesFields.RANK.key]: response[rentalFilesFields.RANK.key],
        [rentalFilesFields.PAN.key]: response[rentalFilesFields.PAN.key],
        [rentalFilesFields.OPENING_DATE.key]: response[rentalFilesFields.OPENING_DATE.key],
        [rentalFilesFields.CLOSING_DATE.key]: response[rentalFilesFields.CLOSING_DATE.key],
        [rentalFilesFields.EXPIRATION_DATE.key]: response[rentalFilesFields.EXPIRATION_DATE.key],
        [rentalFilesFields.CONTRACT.key]: response[rentalFilesFields.CONTRACT.key],
        [rentalFilesFields.RENTAL_EVENTS.key]: response[rentalFilesFields.RENTAL_EVENTS.key]
    };
}

const queryGetRentalFile = (rentalFileId, enabled) => {
    return {
        queryKey: [RENTAL_FILES.DETAILS.queryKey, rentalFileId],
        queryFn: async () => {
            const response = await client.get(replaceParameters(RENTAL_FILES.DETAILS.url, { rentalFileId }));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetRentalFile;
